import { checkoutAppUrl } from '@constants/batch';

export const getAccountsPayableUrl = (env: string, accountsPayableLinkId: string): string => {
  return `${
    checkoutAppUrl[env as keyof typeof checkoutAppUrl]
  }/accounts-payable/${accountsPayableLinkId}`;
};
